var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0335677 29.6984C-0.0735983 29.9663 0.0871508 30.1271 0.355066 30.0199C2.7663 29.4841 5.17754 28.9482 7.58877 28.3588C7.8031 28.3053 7.91027 28.2517 8.07102 28.0909C13.1614 23.0005 18.3054 17.8566 23.3958 12.7662C21.3596 10.73 19.3235 8.69387 17.2873 6.65771C12.1433 11.8017 6.99936 16.9457 1.90897 22.036C1.74822 22.1968 1.69464 22.304 1.64106 22.5183C1.10523 24.9295 0.569398 27.3408 0.0335677 29.6984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6102 0.281311C23.9853 -0.0937703 24.6283 -0.0937703 25.0034 0.281311C26.5573 1.83522 28.1112 3.38913 29.7187 4.99662C30.0938 5.3717 30.0938 6.01469 29.7187 6.44336C27.8969 8.26518 26.1287 10.0334 24.3068 11.8552C22.2707 9.81909 20.2345 7.78293 18.1984 5.74678C20.0202 3.92496 21.842 2.10313 23.6102 0.281311Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0969391a933efd272325df914e6b90e6.svg";
export { ForwardRef as ReactComponent };